import React from 'react';
import './privacyPolicy.css';

const PrivacyPolicy = () => (
  <section id="privacy-policy">
    <h2>Privacy Policy</h2>
    <p>Welcome to Event Planner! Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our application and services.</p>
    
    <h3>Information We Collect</h3>
    <p>We collect the following types of information:</p>
    <ul>
      <li><strong>Personal Information:</strong>
        <ul>
          <li>Email Address: To uniquely identify users and facilitate communication.</li>
          <li>Profile Information: Such as your name and profile picture to personalize your experience.</li>
        </ul>
      </li>
      <li><strong>Google Calendar Data:</strong>
        <ul>
          <li>Events: We access your Google Calendar events to help you manage your events more effectively. This includes creating, editing, and deleting events on your behalf.</li>
          <li>Calendar Settings: To provide you with a seamless event management experience.</li>
        </ul>
      </li>
    </ul>

    <h3>How We Use Your Information</h3>
    <p>We use your information for the following purposes:</p>
    <ul>
      <li><strong>To Provide and Improve Our Services:</strong>
        <ul>
          <li>To personalize your experience by displaying your profile information.</li>
          <li>To manage your events, including creating, editing, and deleting events on your Google Calendar.</li>
        </ul>
      </li>
      <li><strong>To Communicate with You:</strong>
        <ul>
          <li>To send you updates and notifications about your events.</li>
        </ul>
      </li>
      <li><strong>To Comply with Legal Obligations:</strong>
        <ul>
          <li>To ensure our services comply with applicable laws and regulations.</li>
        </ul>
      </li>
    </ul>

    <h3>Sharing Your Information</h3>
    <p>We do not share your personal information with third parties except in the following circumstances:</p>
    <ul>
      <li><strong>With Your Consent:</strong>
        <ul>
          <li>We will share your information with third parties when you have given us explicit permission to do so.</li>
        </ul>
      </li>
      <li><strong>For Legal Reasons:</strong>
        <ul>
          <li>We may disclose your information if required by law or in response to valid requests by public authorities.</li>
        </ul>
      </li>
    </ul>

    <h3>Security</h3>
    <p>We take the security of your personal information seriously. We implement appropriate technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction.</p>

    <h3>Your Rights</h3>
    <p>You have the right to access, update, and delete your personal information. If you wish to exercise these rights, please contact us at [jmaladyn@gmail.com].</p>

    <h3>Changes to This Privacy Policy</h3>
    <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. You are advised to review this Privacy Policy periodically for any changes.</p>

    <h3>Contact Us</h3>
    <p>If you have any questions about this Privacy Policy, please contact us at [jmaladyn@gmail.com].</p>

    <h3>Compliance with Google API Services User Data Policy</h3>
    <p>Event Planner’s use and transfer to any other app of information received from Google APIs will adhere to the Google API Services User Data Policy, including the Limited Use requirements.</p>
  </section>
);

export default PrivacyPolicy;